module.exports = __webpack_public_path__ + "img/noProductList.41ffd2aa.png";